
var sprite = require("C:/git/annenberg-petspace-petbook/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 9.91 11.75\" id=\"arrow-up-fancy\" ><title>Asset 1</title><g data-name=\"Layer 2\"><g data-name=\"Layer 1\"><path d=\"M8.91 6.37a1 1 0 0 1-.71-.29L5 2.84 1.71 6.08A1 1 0 0 1 .29 4.66L5 0l4.62 4.66a1 1 0 0 1-.71 1.71z\"/><path d=\"M5 11.75a1 1 0 0 1-1-1V1.42a1 1 0 0 1 2 0v9.32a1 1 0 0 1-1 1.01z\"/></g></g></symbol>";
module.exports = sprite.add(image, "arrow-up-fancy");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-up-fancy.svg
// module id = 300
// module chunks = 1